import React, {useState, useEffect} from 'react';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';
import styled from "styled-components";
import logo from "../Img/logo@3x.png";
import ThumbsUpComponent from "../Components/Lottie/LottieMain";

const analyticsId = 'G-EK0Y8CQQZH';

const checkMobile = () => {
    var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기
    if ( varUA.indexOf('android') > -1) {
        //안드로이드
        gtag('event', 'Logo_Url', {
            event_category: 'Android',
            event_label: 'Android',
            value: 'Android'
        })
        fbq('track', 'Logo_Url' , {
            value: 'Android'
        })
        return window.open("https://app.adjust.com/t1f5cze", "", "_blank");
    } else if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
        //IOS
        gtag('event', 'Logo_Url', {
            event_category: 'Ios',
            event_label: 'Ios',
            value: 'Ios'
        })
        fbq('track', 'Logo_Url' , {
            value: 'Ios'
        })
        return window.open("https://app.adjust.com/a5ewcmt", "", "_blank");
    } else {
        //아이폰, 안드로이드 외
        gtag('event', 'Logo_Url', {
            event_category: 'Android',
            event_label: 'Android',
            value: 'Android'
        })
        fbq('track', 'Logo_Url' , {
            value: 'Android'
        })
        return window.open("https://app.adjust.com/t1f5cze", "", "_blank");
    }
}

declare const window: any;
declare const gtag: any;
declare const fbq: any;


export const initGA = () => {
    window.dataLayer = window.dataLayer || [];
    gtag('js', new Date());
    gtag('config', analyticsId , {
        page_title: 'Psychology_Open',
        page_location: '/intro',
        page_path: '/intro'
    })
};

initGA();

export const GTM = () => {
    gtag('event', 'Home_Test_Start' , {
        event_category: 'Home_Test_Start',
        event_label: 'Home_Test_Start',
        value: 'Home_Test_Start'
    });
    fbq('track', 'Home_Test_Start' , {
        value: 'Home_Test_Start'
    });
}


const Main = () => {

    return (
        <MainWrap>
            <Contents>
                <TextWrap>
                    <InnerTextWrap>
                        <img src={logo} alt="logo" className="logo" onClick={() => checkMobile()}/>
                        <Wrap>
                            <SubTitle>타로점으로 보는</SubTitle>
                            <Title> 찐본캐 테스트 </Title>
                            <LottieImg>
                                <ThumbsUpComponent/>
                            </LottieImg>
                            <MasterComment>
                                질문을 읽고 끌리는 카드를 선택해보세요
                            </MasterComment>
                            <Link to ="/test"
                                  onClick={GTM}
                            >
                            <Button><label>테스트 시작</label></Button>
                            </Link>
                        </Wrap>
                    </InnerTextWrap>
                </TextWrap>
            </Contents>
        </MainWrap>
    );
};

export default Main;
const MainWrap = styled.div`
            position: absolute;
            text-align: center;
            width: 100%;
`
const Wrap = styled.div`
      
`
const Contents = styled.div `
    height: 100%;
    margin: 0 auto 0 auto;
    display: inline-block;
`
const TextWrap = styled.div `
    margin: 60px 0 0 0;
    float: left;
    width: 375px;
    @media (max-width:767px) {
        margin: 30px 0 0 0;
    }
`
const InnerTextWrap = styled.div `
    float: left;
    margin: 0 30px;
    img {
        width: 124px;
        height: 25px;
        cursor: pointer;
    }
`
const SubTitle = styled.label `
      float: left;
      width: 100%;
      height: 20px;
      font-family: GmarketSansTTF;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #9a9a9a;
      padding: 40px 0 15px 0;
      
      @media (max-width: 767px) {
        padding: 35px 0 15px 0;
        }
      
`

const Title = styled.label `
      float: left;
      width: 100%;
      height: 36px;
      font-family: GmarketSansTTFBold;
      font-size: 36px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #ffffff;
`
const LottieImg = styled.div `
 .thumbs-up {
    padding: 60px 0 30px 0;
    float: left;
    }
      @media (max-width: 767px) {
          .thumbs-up {
          padding: 0 0 0 0;
          margin: 40px 0 20px 0;
          }
     }
`
const Button = styled.button`
  font-family: GmarketSansTTFBold;
  width: 100%;
  height: 55px;
  margin: 20px 0 0 0;
  border-radius: 8px;
  border: 0;
  outline: 0;
  background-color: #ffcf24;
  cursor: pointer;
  float: left;
  label {
      font-family: GmarketSansTTFBold;
      font-size: 24px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: #201d3a;
      cursor: pointer;
  }
}
`
const MasterComment = styled.label`
  font-family: NanumGothic;
  font-size: 12px;
  height: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #dddddd;
`
